var SUBCLUSTERS;
(function (SUBCLUSTERS) {
    SUBCLUSTERS["MANAGING_PROJECTS_PORTFOLIO"] = "managing_projects_portfolio";
    SUBCLUSTERS["PROJECT_MANAGEMENT"] = "project_management";
    SUBCLUSTERS["HR_SERVICES"] = "hr_services";
    SUBCLUSTERS["RECRUITING"] = "recruiting";
    SUBCLUSTERS["ONBOARDING_OFFBOARDING"] = "onboarding_offboarding";
    SUBCLUSTERS["EMPLOYEE_ONBOARDING"] = "employee_onboarding";
    SUBCLUSTERS["RECRUITMENT_PIPELINE"] = "recruitment_pipeline";
    SUBCLUSTERS["EMPLOYEE_EXPERIENCE"] = "employee_experience";
    SUBCLUSTERS["HR_REQUESTS"] = "hr_requests";
    SUBCLUSTERS["HR_RECRUITING"] = "hr_recruiting";
    SUBCLUSTERS["EMPLOYEE_DIRECTORY"] = "employee_directory";
    SUBCLUSTERS["COMPANY_EVENTS"] = "company_events";
    SUBCLUSTERS["TASKS"] = "tasks";
    SUBCLUSTERS["RESOURCE_MANAGEMENT"] = "resource_management";
    SUBCLUSTERS["MANAGING_ROUTINE_PROCESSES"] = "managing_routine_processes";
    SUBCLUSTERS["REPORTING_TO_EXECUTIVES"] = "reporting_to_executives";
    SUBCLUSTERS["BUSINESS_OPERATIONS"] = "business_operations";
    SUBCLUSTERS["CRM"] = "crm";
    SUBCLUSTERS["CONSTRUCTION_SCHEDULING"] = "construction_scheduling";
    SUBCLUSTERS["CONSTRUCTION_PLANNING"] = "construction_planning";
    SUBCLUSTERS["CLIENT_PROJECTS"] = "client_projects";
    SUBCLUSTERS["CREATIVE_PLANNING"] = "creative_planning";
    SUBCLUSTERS["CONTENT_CALENDAR"] = "content_calendar";
    SUBCLUSTERS["MEDIA_PRODUCTION"] = "media_production";
    SUBCLUSTERS["CREATIVE_REQUESTS"] = "creative_requests";
    SUBCLUSTERS["PRODUCT_LAUNCHES"] = "product_launches";
    SUBCLUSTERS["KNOWLEDGE_BASE"] = "knowledge_base";
    SUBCLUSTERS["TICKETS_AND_REQUESTS"] = "tickets_and_requests";
    SUBCLUSTERS["IT_SERVICE_DESK"] = "it_service_desk";
    SUBCLUSTERS["EVENT_MANAGEMENT"] = "event_management";
    SUBCLUSTERS["FUNDRAISING_CRM"] = "fundraising_crm";
    SUBCLUSTERS["GRANTS_MANAGEMENT"] = "grants_management";
    SUBCLUSTERS["VOLUNTEERS_REGISTRATION"] = "volunteers_registration";
    SUBCLUSTERS["EMERGENCY_RESPONSE"] = "emergency_response";
    SUBCLUSTERS["INDIVIDUAL_WORK"] = "individual_work";
    SUBCLUSTERS["STUDENT_ORGANIZATIONS"] = "student_organizations";
    SUBCLUSTERS["ACADEMIC_RESEARCH"] = "academic_research";
    SUBCLUSTERS["GROUP_ASSIGNMENTS"] = "group_assignments";
    SUBCLUSTERS["CURRICULUM_SYLLABUS_MANAGEMENT"] = "curriculum_syllabus_management";
    SUBCLUSTERS["ADMINISTRATIVE_WORK"] = "administrative_work";
    SUBCLUSTERS["PROJECT_PLANNING"] = "project_planning";
    SUBCLUSTERS["CUSTOMER_PROJECTS"] = "customer_projects";
    SUBCLUSTERS["ACCOUNTING"] = "accounting";
    SUBCLUSTERS["BUDGET_MANAGEMENT"] = "budget_management";
    SUBCLUSTERS["FORECAST_PLANNING_ANALYTICS"] = "forecast_planning_analytics";
    SUBCLUSTERS["BILLING_INVOICING"] = "billing_invoicing";
    SUBCLUSTERS["SOCIAL_MEDIA_MARKETING"] = "social_media_marketing";
    SUBCLUSTERS["STRATEGIC_PLANNING"] = "strategic_planning";
    SUBCLUSTERS["MARKETING_OPERATIONS"] = "marketing_operations";
    SUBCLUSTERS["CAMPAIGN_TRACKING"] = "campaign_tracking";
    SUBCLUSTERS["EMAIL_MARKETING"] = "email_marketing";
    SUBCLUSTERS["CREATIVE"] = "creative";
    SUBCLUSTERS["ROADMAP_PLANNING"] = "roadmap_planning";
    SUBCLUSTERS["SCRUM_SOFTWARE"] = "scrum_software";
    SUBCLUSTERS["KANBAN"] = "kanban";
    SUBCLUSTERS["BUGS_TRACKING"] = "bugs_tracking";
    SUBCLUSTERS["OPERATIONS_PROCESSES"] = "operations_processes";
    SUBCLUSTERS["REMOTE_WORK"] = "remote_work";
    SUBCLUSTERS["LEGAL_REQUESTS"] = "legal_requests";
    SUBCLUSTERS["PROCUREMENT"] = "procurement";
    SUBCLUSTERS["RELEASE_PLAN"] = "release_plan";
    SUBCLUSTERS["FEATURES_BACKLOG"] = "features_backlog";
    SUBCLUSTERS["LEADS_CAPTURING"] = "leads_capturing";
    SUBCLUSTERS["SALES_PIPELINE"] = "sales_pipeline";
    SUBCLUSTERS["CONTACT_MANAGEMENT"] = "contact_management";
    SUBCLUSTERS["MARKETING_ACTIVITIES"] = "marketing_activities";
    SUBCLUSTERS["LEAD_MANAGEMENT"] = "lead_management";
    SUBCLUSTERS["QUOTES_INVOICES"] = "quotes_invoices";
    SUBCLUSTERS["DIGITAL_ASSET_MANAGEMENT"] = "digital_asset_management";
    SUBCLUSTERS["REPORTING"] = "reporting";
    SUBCLUSTERS["SOFTWARE_DEVELOPMENT"] = "software_development";
    SUBCLUSTERS["TASK_MANAGEMENT"] = "task_management";
    SUBCLUSTERS["SPRINT_MANAGEMENT"] = "sprint_management";
    SUBCLUSTERS["TEAM_MANAGEMENT"] = "team_management";
    SUBCLUSTERS["RETROSPECTIVE"] = "retrospective";
    SUBCLUSTERS["REPORTS_DASHBOARDS"] = "reports_dashboards";
    SUBCLUSTERS["PRIORITIZE_PERSONAL_WORK"] = "prioritize_personal_work";
    SUBCLUSTERS["BUDGETING"] = "budgeting";
    SUBCLUSTERS["CODE_REVIEW_COLLABORATION"] = "code_review_collaboration";
    SUBCLUSTERS["CI_CD_PROCESSES"] = "ci_cd_processes";
    SUBCLUSTERS["MANAGE_TEAM_CAPACITY"] = "manage_team_capacity";
    SUBCLUSTERS["AUTOMATIONS"] = "automations";
    SUBCLUSTERS["STORIES_EPICS_MANAGEMENT"] = "stories_epics_management";
    SUBCLUSTERS["RELEASE_MANAGEMENT"] = "release_management";
    SUBCLUSTERS["TRACKING_PRODUCT_METRICS"] = "tracking_product_metrics";
    SUBCLUSTERS["CROSS_TEAM_COLLABORATION"] = "cross_team_collaboration";
    SUBCLUSTERS["MARKET_RESEARCH"] = "market_research";
    SUBCLUSTERS["CUSTOMER_COMMUNICATION"] = "customer_communication";
    SUBCLUSTERS["FEATURE_PRIORITIZATION"] = "feature_prioritization";
    SUBCLUSTERS["BACKLOG_MANAGEMENT"] = "backlog_management";
    SUBCLUSTERS["OTHER"] = "other";
})(SUBCLUSTERS || (SUBCLUSTERS = {}));

export { SUBCLUSTERS };
